"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRef = exports.getSharedKey = void 0;
const json_1 = require("@stoplight/json");
function inferContext(path) {
    if (path.length < 2 || path[0] !== 'paths')
        return 'service';
    if (path.length === 2 || path[3] === 'parameters' || path[3] === 'servers')
        return 'path';
    return 'operation';
}
const SHARED_COMPONENTS_KEYS = new WeakMap();
function getSharedKey(value) {
    return SHARED_COMPONENTS_KEYS.get(value);
}
exports.getSharedKey = getSharedKey;
const resolveRef = function (target) {
    const { value: resolved, location } = (0, json_1.resolveInlineRefWithLocation)(this.document, target.$ref);
    const context = inferContext(location);
    if (context !== null && this.context !== context) {
        this.context = context;
    }
    if (typeof resolved === 'object' && resolved !== null && context === 'service') {
        SHARED_COMPONENTS_KEYS.set(resolved, location[0] === 'components' ? location[2] : location[1]);
    }
    return resolved;
};
exports.resolveRef = resolveRef;
//# sourceMappingURL=resolver.js.map